// Who approves or rejects a CMS command (task cms-quyen-hien-thi): ONE rule for the API (routes/admin/commands.ts,
// the approve / reject routes) and the admin page Chi tiet lenh (Duyet / Tu choi buttons), so they cannot drift.
// The API also hides founder-only commands from every other role (lib/founder-only.ts): that check stays there.
export const COMMAND_TYPES = ['MONEY', 'LOCK', 'CONFIG', 'RESULT', 'EDIT', 'FLAG', 'PLAYER_FLAG', 'PASSWORD', 'REFUND', 'TRANSFER',
    'JACKPOT', 'CHAT_DELETE', 'CHAT_SEND', 'COOLOFF', 'LODE', 'VIP', 'POOL_RESET'];
export const APPROVE_PERMISSION = {
    MONEY: 'money.approve',
    LOCK: 'users.lock',
    CONFIG: 'games.config',
    RESULT: 'game:control',
    EDIT: 'bet:result:edit',
    FLAG: 'users.testFlag',
    PLAYER_FLAG: 'users.lock',
    PASSWORD: 'users.password',
    REFUND: 'rounds.refund',
    TRANSFER: 'money.approve',
    JACKPOT: 'jackpots.manage',
    CHAT_DELETE: 'chat.moderate',
    CHAT_SEND: 'chat.moderate',
    COOLOFF: 'users.coolOffLift',
    LODE: 'lode.approve',
    VIP: 'vip.payout.approve',
    POOL_RESET: 'games.config',
};
const tenCauHinh = (c) => (c.type === 'CONFIG' ? c.payload?.ten : undefined);
// a lo de config (payout rates, limits) is approved by a lo de approver, whether the command came from
// the lo de pages or from a revert in the config history
const loDe = (c) => c.sourceType?.startsWith('lode.') || String(tenCauHinh(c) ?? '').startsWith('lode_');
// luat hu (config `hu`, trang Hu tab Luat hu) duyet boi nguoi co jackpots.manage nhu lenh JACKPOT, du lenh
// tao tu trang hay tu hoan tac trong lich su cau hinh
const luatHu = (c) => tenCauHinh(c) === 'hu';
// cau hinh poker_ban / poker_ban_tao (trang Poker tab Quan ly ban, Tao ban) duyet boi nguoi co game:control
const pokerBan = (c) => tenCauHinh(c) === 'poker_ban' || tenCauHinh(c) === 'poker_ban_tao';
/** the permission that approves or rejects the command ('' for a type this build does not know: nobody) */
export const approvePermission = (c) => (loDe(c) ? 'lode.approve' : luatHu(c) ? 'jackpots.manage'
    : pokerBan(c) ? 'game:control' : APPROVE_PERMISSION[c.type] ?? '');
//# sourceMappingURL=approve.js.map